import { makeAutoObservable, runInAction } from 'mobx';
import { apiClient } from '../api/apiclient';
import { academyStore } from './AcademyStore';
export class AssessmentStore {
    constructor() {
        this.assessments = [];
        this.loading = false;
        this.error = null;
        this.selectedAssessment = null;
        this.isDialogOpen = false;
        this.isEditing = false;
        makeAutoObservable(this);
    }
    // Actions
    async fetchAssessments(academyId, filters) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getAssessmentsByAcademyId(academyId, filters);
            if (response.success) {
                runInAction(() => {
                    this.assessments = response.data;
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch assessments';
                this.loading = false;
            });
        }
    }
    async createAssessment(assessmentData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.createAssessment(academyStore.currentAcademy.id, assessmentData);
            if (response.success) {
                runInAction(() => {
                    this.assessments.unshift(response.data);
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to create assessment';
                this.loading = false;
            });
            throw error;
        }
    }
    async updateAssessment(id, assessmentData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.updateAssessment(academyStore.currentAcademy.id, id, assessmentData);
            if (response.success) {
                runInAction(() => {
                    const index = this.assessments.findIndex(assessment => assessment.id === id);
                    if (index !== -1) {
                        this.assessments[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to update assessment';
                this.loading = false;
            });
            throw error;
        }
    }
    async deleteAssessment(id) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.deleteAssessment(academyStore.currentAcademy.id, id);
            if (response.success) {
                runInAction(() => {
                    this.assessments = this.assessments.filter(assessment => assessment.id !== id);
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to delete assessment';
                this.loading = false;
            });
            throw error;
        }
    }
    // Dialog actions
    openCreateDialog() {
        this.selectedAssessment = null;
        this.isEditing = false;
        this.isDialogOpen = true;
    }
    openEditDialog(assessment) {
        this.selectedAssessment = assessment;
        this.isEditing = true;
        this.isDialogOpen = true;
    }
    closeDialog() {
        this.isDialogOpen = false;
        this.selectedAssessment = null;
        this.isEditing = false;
    }
    // Computed
    get hasAssessments() {
        return this.assessments.length > 0;
    }
    get isLoading() {
        return this.loading;
    }
    get hasError() {
        return this.error !== null;
    }
    // Get assessment areas (parentId is null)
    get assessmentAreas() {
        return this.assessments.filter(a => a.parentId === null);
    }
    // Get criteria for a specific area
    getCriteriaForArea(areaId) {
        return this.assessments.filter(a => a.parentId === areaId);
    }
}
export const assessmentStore = new AssessmentStore();
